import { h } from '@stencil/core';
import { generateSrcSet, generateMedia } from '@pes-ui/utils';
export class CategoryBanner {
  constructor() {
    this.name = undefined;
    this.description = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.imageSourceSets = [];
  }
  render() {
    return (h("section", { class: "category-banner-container" }, h("section", { class: "category-banner" }, h("div", { class: "category-banner__image-container" }, h("picture", { class: "category-banner__image" }, this.imageSourceSets.map(({ minWidth, maxWidth, urls }) => (h("source", { media: generateMedia(minWidth, maxWidth), srcSet: generateSrcSet(urls) }))), this.imageSourceSets.length > 0 && (h("img", { src: this.imageSourceSets[0].originalUrl, alt: "" })))), h("div", { class: "category-banner__content" }, h("div", { class: "category-banner__content-inner" }, h("h3", { class: "category-banner__heading" }, this.name), h("pes-description", { variant: "light", text: this.description, expandLabel: this.readMoreLabel, collapseLabel: this.readLessLabel }))))));
  }
  static get is() { return "pes-category-banner"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["category-banner.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["category-banner.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "header"
        },
        "attribute": "name",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "collapsible/expandable text"
        },
        "attribute": "description",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read more\""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read less\""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "imageSourceSets": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ImageSourceSet[]",
          "resolved": "ImageSourceSet[]",
          "references": {
            "ImageSourceSet": {
              "location": "import",
              "path": "../../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      }
    };
  }
}
